import useDictStore from '../store/Dict'
import RemoteCenter from '../remoteservice/RemoteCenter'
import { ref, toRefs } from 'vue';
/**
 * 获取字典数据
 */
export function useDict(...args) {
    const res = ref({});
    return (() => {
        args.forEach((dictType, index) => {
            res.value[dictType] = [];
            const dicts = useDictStore().getDict(dictType);
            if (dicts) {
                res.value[dictType] = dicts;
            } else {
                RemoteCenter.getDicts(dictType).then(resp => {
                    res.value[dictType] = resp.map(p => ({ label: p.dictLabel, value: p.dictValue, elTagType: p.listClass, elTagClass: p.cssClass }))
                    useDictStore().setDict(dictType, res.value[dictType]);
                })
            }
        })
        return toRefs(res.value);
    })()
}
export function handleTree(data, id, parentId, children) {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
    };

    var childrenListMap = {};
    var nodeIds = {};
    var tree = [];

    for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
    }

    for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
            tree.push(d);
        }
    }

    for (let t of tree) {
        adaptToChildrenList(t);
    }

    function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
            o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c);
            }
        }
    }
    return tree;
}
export function addDateRange(params, dateRange, propName) {
    let search = params;
    search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
    dateRange = Array.isArray(dateRange) ? dateRange : [];
    if (typeof (propName) === 'undefined') {
        search.params['beginTime'] = dateRange[0];
        search.params['endTime'] = dateRange[1];
    } else {
        search.params['begin' + propName] = dateRange[0];
        search.params['end' + propName] = dateRange[1];
    }
    return search;
}

// class getPermissios {
//     permissios = [];
//     setPermissios(data,code) {
//         let datas=data;
//         datas.forEach(it=>{
//             this.permissios.push(code+it.component)
//             if(it.children){
//                 setPermissios(it.children,it.component)
//             }
//         })
//     }
// }
// export default getPermissios
export function getPermissios(data, code) {
    var permissios = [];
    var datas = JSON.parse(JSON.stringify(data));
    var treedata = handleTree(datas, 'menuId')
    // console.log(treedata)
    datas.forEach(it => {
        let str = ''
        let ids = JSON.parse(JSON.stringify(getParent(datas, treedata, it.menuId)))
        // console.log(ids)
        // console.log(it!='')
        if (it.query) {
            console.log(it)
            permissios.push(it.path + "?" + it.query)
        }
        ids.forEach((its, index) => {
            let code = ids.length == 1 || index == ids.length - 1 ? '' : '/'
            str += `${its.component + code}`
        })
        // console.log(str,ids)
        permissios.push(str)
    })

    return permissios
}
// function findNode(datas,data){
//     if(!data.parentId){
//         return data.component
//     }else{
//       let arr= [];

//     }
// }
// function getper(list,ids){
//      let per
//      ids.forEach(it=>{
//         list.forEach()
//      })
// }
function getParent(datas, list, id) {
    if (!list || !id) {
        return ''
    }
    let arr = [];
    let findParent = (datas, data, nodeId, parentId) => {
        for (var i = 0, length = data.length; i < length; i++) {
            let node = data[i];
            if (node.menuId == nodeId) {
                let n = datas.filter(it => it.menuId == nodeId)
                arr.unshift(n[0]);
                if (nodeId == list[0].menuId) {
                    break
                }
                findParent(datas, list, parentId);
                break
            } else {
                if (node.children) {
                    findParent(datas, node.children, nodeId, node.menuId);
                }
                continue
            }
        }
        return arr;
    }
    return findParent(datas, list, id);
}
export function findRows(datas, code, value) {
    let findRow = null;
    datas.forEach(it => {
        if (it[code] == value) {
            findRow = it
        }

    })
    if (!findRow) {
        datas.forEach(it => {
            if (it.children && it.children.length > 0) {
                // return findRows(it.children, code, value)
                console.log(findRows(it.children, code, value))
                if (findRows(it.children, code, value)) {
                    findRow = findRows(it.children, code, value)
                } else {
                    findRows(it.children, code, value)
                }
            }
        })
    }

    return findRow
}